import { getRandomInt } from '@cian/newbuilding-utils';

const SOLDOUT_NOTIFICATION_INT_COOKIE = 'soldout_notification_int';

export const getSoldoutNotificationInt = (newbuildingId: number) => {
  const storage = window.localStorage.getItem(SOLDOUT_NOTIFICATION_INT_COOKIE);
  const savedValue = (storage && JSON.parse(storage)) || {};
  const quantity = savedValue[newbuildingId];

  const now = new Date().getTime();
  const savedValueExpires = quantity ? new Date(quantity.expires).getTime() : 0;

  if (quantity && savedValueExpires > now) {
    return quantity.random;
  }

  const random = getRandomInt(15, 2);
  const current = new Date();
  const expires = new Date(current.getTime() + 86400000);
  const newData = JSON.stringify({
    ...savedValue,
    [newbuildingId]: { random, expires },
  });
  window.localStorage.setItem(SOLDOUT_NOTIFICATION_INT_COOKIE, newData);

  return random;
};
